import React from "react";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";

// https://material-ui-pickers.dev/demo/datepicker

const OSSDatePicker = ({
  classes,
  format = "MM/dd/yyyy",
  minDateMessage = "Invalid Range",
  maxDateMessage = "Invalid Range",
  onChange = () => {},
  variant = "inline",
  margin = "dense",
  ...rest
}) => {
  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <KeyboardDatePicker
        margin={margin}
        variant={variant}
        format="MM/dd/yyyy"
        disableToolbar={true}
        maxDateMessage="Invalid Range"
        minDateMessage="Invalid Range"
        onChange={onChange}
        {...rest}
      />
    </MuiPickersUtilsProvider>
  );
};

export default OSSDatePicker;
